import React, { Fragment } from 'react';
import { Logo, Image, Link, Section, FooterColumn, FooterForm } from 'components';
import { useStaticQuery, graphql } from 'gatsby';
import * as styles from './styles.module.scss';

const Footer = ({ location }) => {
  // LINKS DATA FROM SETTINGS
  const footerSettingsQuery = graphql`
    query {
      ...FooterSettings
    }
  `;
  const { footerSettings } = useStaticQuery(footerSettingsQuery);
  const { data } = footerSettings;
  const {
    footer_nav: footerNav,
    instagram_link: instagramLink,
    linkedin_link: linkedInLink,
    twitter_link: twitterLink,
    facebook_link: facebookLink,
    youtube_link: youtubeLink,
  } = data;

  // FOOTER TEXT LINKS
  const footerNav1 = [];
  const footerNav2 = [];
  const footerNav3 = [];

  footerNav.forEach((item) => {
    if (item?.parent_link === 'Sitemap') {
      footerNav1.push(item);
    }
    if (item?.parent_link === 'Company') {
      footerNav2.push(item);
    }
    if (item?.parent_link === 'Legal') {
      footerNav3.push(item);
    }
  });

  // FOOTER SOCIAL LINKS
  const socialLinksArr = [
    { class: styles.twitter, link: twitterLink, alt: 'Twitter' },
    { class: styles.linkedin, link: linkedInLink, alt: 'LinkedIn' },
    { class: styles.instagram, link: instagramLink, alt: 'Instagram' },
    { class: styles.youtube, link: youtubeLink, alt: 'Youtube' },
    { class: styles.facebook, link: facebookLink, alt: 'Facebook' },
  ];

  const socialLinks = socialLinksArr.filter((socialLink) => socialLink.link?.url);

  return (
    <footer className={styles.footer}>
      <Section>
        <div className={`${styles.container}`}>
          <Logo className={styles.logo} />
          <FooterColumn title="Sitemap" links={footerNav1?.length && footerNav1} />
          <FooterColumn title="Company" links={footerNav2?.length && footerNav2} />
          <FooterColumn title="Legal" links={footerNav3?.length && footerNav3} />
          <FooterForm className={styles.newsletter} />
        </div>
        <div className={styles.subContainer}>
          <span className={styles.sitemap}>
            © {new Date().getFullYear()} PAC Capital All Rights Reserved.{' '}
            <a href="https://mammoth.tech" title="Made by Mammoths" target="_blank" rel="noreferrer">
              Made by Mammoths
            </a>
          </span>
          {socialLinks.length > 0 && (
            <div className={styles.socialLinksContainer}>
              {socialLinks?.map((item) => (
                <Fragment key={item?.link?.url}>
                  {item?.icon}
                  <Link to={item?.link?.url || '/'} className={`${styles.socialIcon} ${item?.class}`} alt={item?.alt} />
                </Fragment>
              ))}
            </div>
          )}
        </div>
      </Section>
    </footer>
  );
};

export default Footer;
